import React, { Fragment } from "react";
import { Col, Container, Row } from "react-bs4grid";
import { withRouter, Link } from "react-router-dom";
import { Form, Formik } from "formik";

import TextField from "../../../formiks/TextField/TextField";
import SubmitButton from "../../../formiks/SubmitButton/SubmitButton";
import FormError from "../../../formiks/FormError/FormError";
import useAppState from "../../../StateMachine/useAppState";
import {useTranslation} from "react-i18next";
import * as Yup from "yup";

function Login({ history }) {
  const {t} = useTranslation();
  const account = useAppState("account");

    const loginFormSchema = Yup.object().shape({
        password: Yup.string()
            .min(5, t("invalidPassword"))
            .required(t("required")),
        email: Yup.string()
            .email(t("invalidEmail"))
            .required(t("required"))
    });

  return (
    <Fragment>
      <div className="pt-32">
        <Container>
          <Row>
            <Col lg={{ offset: 1 }}>
              <h2 className="mb-32">{t("earnWithPlastx")}</h2>
            </Col>
          </Row>
          <Row>
            <Col className="pb-64" lg={{ size: 4, offset: 1 }}>
              <div style={{
                border: "1px solid #FF7043",
                fontWeight: "bold",
                fontSize: "18px",
                paddingTop: "2px",
                paddingBottom: "2px",
                paddingLeft: "2px",
                paddingRight: "2px"
              }}>
                <Link to="/user/signup">{t("dontHaveAnAccountRegisterNow")}</Link>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={{ size: 4, offset: 1 }}>
              <h3 className="mb-32">{t("login")}</h3>
            </Col>
          </Row>
          <Row>
            <Col lg={{ size: 4, offset: 1 }}>
              <Formik
                validationSchema={loginFormSchema}
                initialValues={{
                  email: "",
                  password: ""
                }}
                onSubmit={(values, formikActions) => {
                  account
                    .login(values)
                    .then(() => {
                      history.push("/jobs/my-jobs");
                    })
                    .catch(error => {
                      console.log("error", error);
                      formikActions.setStatus("Unable to log in with supplied credentials");
                      formikActions.setSubmitting(false);
                    });
                }}
                render={({ errors, isSubmitting }) => {
                  return (
                    <Form>
                      <TextField
                        label={t("username")}
                        name="email"
                        type="email"
                        placeholder={t("username")}
                        autoFocus={true}
                      />
                      <TextField
                        label={t("password")}
                        name="password"
                        type="password"
                        placeholder="********"
                      />
                      <SubmitButton
                        className="btn btn-primary"
                        value={t("login")}
                        submittingValue={t("login") + " ..."}
                      />

                      <FormError />
                    </Form>
                  );
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col className="pb-96" lg={{ size: 4, offset: 1 }}>
              <span>
                <Link to="/user/forgot">{t("forgotPassword")}</Link>
              </span>
            </Col>
          </Row>
        </Container>
      </div>
    </Fragment>
  );
}

export default withRouter(Login);
